// 表格和圖表組件
export default {
  // 表頭統計
  totalRecords: "共計",
  records: "條數據",
  loading: "拼命加載中",

  // 表格列名
  blockchain: "公鏈",
  address: "地址",
  mainBalance: "主幣餘額",
  usdtBalance: "USDT餘額",
  totalAsset: "總資產（USDT）",
  remark: "備註",
  assetBalanceChange: "總資產餘額變化（近7天）",
  action: "操作",

  // 操作按鈕
  delete: "刪除",
  addRemark: "點擊添加備註",
  loadMore: "加載更多數據(每次加載20條)",
  collapse: "收起",
  downloadDetails: "下載數據明細",

  // 空狀態
  noData: "暫無數據",

  // 消息提示
  copySuccess: "複製成功",
  addressNotFound: "沒有查出該地址",
  deleteConfirm: "是否刪除此條地址?",
  deleteSuccess: "刪除成功",
  deleteCancelled: "已取消刪除",
  lastAddressWarning: "此地址為最後一條，不可刪除",
  remarkSuccess: "備註修改成功",

  // 對話框
  tip: "刪除確認",
  confirm: "確定",
  cancel: "取消",
  warning: "警告",

  // 下載文件名
  balanceData: "餘額數據",
};
